import theme from '../../../../themes/green';

const styles = {
  headline: Object.assign(...theme.font, {
    fontFamily: 'Roboto',
    fontSize: '16px',
    fontWeight: '500',
    color: 'white',
    marginBottom: '5px',
    marginTop: '20px',
  }),
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/Project/ProjectDetails/ProjectDetailsHeader/ProjectDetailsHeader.styles.js